import { api } from './api';

/**
 * 개선요청 **읽음 표시** — 2026-09-29 부터 서버(계정 단위)가 정본이다.
 *
 * 예전엔 읽음을 브라우저(localStorage)에 뒀다 → PC·브라우저마다 따로라 way 가 「다른 PC 에 오니 새 답변이라고 나와」.
 * 지금은 상세를 열면 서버가 `improvement_seen` 에 남기고, 목록의 `unread` 도 서버가 판정한다(functions/src/improvement.ts).
 *
 * 여기 남은 일은 **옛 브라우저 기록을 한 번 서버로 옮기는 것**뿐이다 — 옮기고 나면 키를 지운다.
 * ⚠️ 저장이 막힌 브라우저(시크릿·사이트 데이터 차단)에서도 화면은 그대로 돌아야 하므로 전부 try/catch.
 */

const KEY = 'businweb.improveSeen.v1';
let pending: Promise<void> | null = null;

export function importLocalSeen(): Promise<void> {
  if (pending) return pending;
  let seen: Record<string, string> | null = null;
  try {
    const raw = localStorage.getItem(KEY);
    seen = raw ? (JSON.parse(raw) as Record<string, string>) : null;
  } catch {
    seen = null;
  }
  if (!seen || Object.keys(seen).length === 0) return (pending = Promise.resolve());
  pending = api
    .importImprovementSeen({ seen })
    .then(() => {
      try {
        localStorage.removeItem(KEY);
      } catch {
        /* 못 지우면 다음에 한 번 더 옮길 뿐이다(더 늦은 쪽만 남는다). */
      }
    })
    .catch(() => {
      /* 옮기기 실패는 목록을 막지 않는다 — 새 답변이 한 번 더 보일 뿐이다. */
      pending = null;
    });
  return pending;
}
